import React from 'react';

import {IMG_DIR} from '#Client/components/constants';
import {
  cell,
  explanation,
  explanationText,
  fadeIn,
  fadeInDelays,
  fixedCell,
  grid,
  howToPlayCheck,
  letterSpan,
  whiteText,
} from '#Client/components/HowToPlayModal/HowToPlayModal.css';
import {Modal} from '#Client/components/Modal/Modal';
import {Check} from '#Client/images/Check';

type HowToPlayModalProps = {
  onClose: () => void;
};
export const HowToPlayModal = ({onClose}: HowToPlayModalProps) => {
  return (
    <Modal
      image={`${IMG_DIR}icon_how_to_play.png`}
      title="How To Play"
      onClose={onClose}
    >
      <>
        <p>Guess the 5 words that make up the Word Crunch.</p>
        <p>
          The words go left to right, and{' '}
          <em>
            <b>those same words</b>
          </em>{' '}
          go top to bottom.
        </p>
        <p>
          Some letters are <b className={whiteText}>fixed</b> and cannot be
          moved.
        </p>
        <hr />
        <h3>Example</h3>
        <table className={grid}>
          <tbody>
            <tr>
              <td className={cell}>
                <span className={`${letterSpan} ${fadeIn}`}>C</span>
              </td>
              <td className={cell}>
                <span className={`${letterSpan} ${fadeIn} ${fadeInDelays[50]}`}>
                  H
                </span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[100]}`}
                >
                  E
                </span>
              </td>
              <td className={`${cell} ${fixedCell}`}>
                <span className={letterSpan}>S</span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[200]}`}
                >
                  T
                </span>
              </td>
            </tr>
            <tr>
              <td className={cell}>
                <span className={`${letterSpan} ${fadeIn} ${fadeInDelays[50]}`}>
                  H
                </span>
              </td>
              <td className={`${cell} ${fixedCell}`}>
                <span className={letterSpan}>E</span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[6050]}`}
                >
                  L
                </span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[3000]}`}
                >
                  L
                </span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[6150]}`}
                >
                  O
                </span>
              </td>
            </tr>
            <tr>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[100]}`}
                >
                  E
                </span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[6050]}`}
                >
                  L
                </span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[9000]}`}
                >
                  B
                </span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[3050]}`}
                >
                  O
                </span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[9100]}`}
                >
                  W
                </span>
              </td>
            </tr>
            <tr>
              <td className={`${cell} ${fixedCell}`}>
                <span className={letterSpan}>S</span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[3000]}`}
                >
                  L
                </span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[3050]}`}
                >
                  O
                </span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[3100]}`}
                >
                  P
                </span>
              </td>
              <td className={`${cell} ${fixedCell}`}>
                <span className={letterSpan}>E</span>
              </td>
            </tr>
            <tr>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[200]}`}
                >
                  T
                </span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[6150]}`}
                >
                  O
                </span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[9100]}`}
                >
                  W
                </span>
              </td>
              <td className={`${cell} ${fixedCell}`}>
                <span className={letterSpan}>E</span>
              </td>
              <td className={cell}>
                <span
                  className={`${letterSpan} ${fadeIn} ${fadeInDelays[12000]}`}
                >
                  R
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <hr />
        <p className={explanation}>
          <Check className={howToPlayCheck} />
          <span className={explanationText}>
            A green checkmark means that the word in that row/column is a valid
            English word, but not necessarily the correct word that would solve
            the puzzle.
          </span>
        </p>
        <p>A new set of Word Crunch puzzles will be available every day!</p>
      </>
    </Modal>
  );
};
